import { ReactElement, useEffect } from 'react';
import './Contact.scss';

function Contact(): ReactElement {
  const portalId = process.env.REACT_APP_HUBSPOT_PORTAL_ID;
  const formId = process.env.REACT_APP_HUBSPOT_FORM_ID;

  // Load HubSpot form embed script
  useEffect(() => {
    if (!portalId) {
      console.warn('HubSpot portal ID not configured');
      return;
    }

    const scriptSrc = `https://js-na2.hsforms.net/forms/embed/${portalId}.js`;

    // Check if script is already loaded to avoid duplicates
    const existingScript = document.querySelector(`script[src="${scriptSrc}"]`);

    if (!existingScript) {
      const script = document.createElement('script');
      script.src = scriptSrc;
      script.defer = true;
      script.charset = 'utf-8';
      script.type = 'text/javascript';

      document.body.appendChild(script);

      // Cleanup function
      return () => {
        const scriptToRemove = document.querySelector(
          `script[src="${scriptSrc}"]`
        );
        if (scriptToRemove && scriptToRemove.parentNode) {
          scriptToRemove.parentNode.removeChild(scriptToRemove);
        }
      };
    }
  }, [portalId]);

  return (
    <section className="contact" id="contact">
      <div className="container">
        <h2 className="section-title">Get In Touch</h2>

        <div className="contact-wrapper">
          <div className="contact-left">
            <p className="section-subtitle">
              Ready to transform your business? Contact us today
            </p>

            <div className="contact-info">
              <div className="info-item">
                <h3>📞 Phone</h3>
                <p>
                  <a href="tel:+12623434293">+1 (262) 343-4293</a>
                </p>
              </div>
              <div className="info-item">
                <h3>✉️ Email</h3>
                <p>
                  Sales:{' '}
                  <a href="mailto:sales@tmsintegration.com">
                    sales@tmsintegration.com
                  </a>
                </p>
                <p>
                  Support:{' '}
                  <a href="mailto:support@tmsintegration.com">
                    support@tmsintegration.com
                  </a>
                </p>
              </div>
            </div>
          </div>

          {formId && (
            <div
              className="hs-form-frame"
              data-region="na2"
              data-form-id={formId}
              data-portal-id={portalId}
            ></div>
          )}
        </div>
      </div>
    </section>
  );
}

export default Contact;
